import { HStack, VStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { Skeleton } from 'native-base';

export const Loading = () => {
  return (
    <VStack
      shadow={0.5}
      borderRadius={Spacing['inset.nano']}
      backgroundColor={Color['neutral.white']}
      paddingX={Spacing['inset.xs']}
      paddingY={Spacing['inset.xs']}
      marginBottom={Spacing['inset.nano']}
      justifyContent={'space-between'}
      height={170}>
      <HStack alignContent={'center'} alignItems={'center'} justifyContent={'space-between'}>
        <Skeleton
          borderRadius={Spacing['inline.nano']}
          height={18}
          width={'79%'}
          marginRight={Spacing['inset.nano']}
        />

        <Skeleton size={'8'} borderRadius={'full'} />
      </HStack>

      <HStack width={'100%'} justifyContent={'space-between'}>
        <VStack width={'30%'}>
          <Skeleton
            marginBottom={Spacing['inset.quarck']}
            borderRadius={Spacing['inline.nano']}
            height={18}
          />
          <Skeleton
            width={'90%'}
            borderRadius={Spacing['inline.nano']}
            height={18}
            marginRight={Spacing['inset.nano']}
          />
        </VStack>
        <VStack width={'30%'}>
          <Skeleton
            marginBottom={Spacing['inset.quarck']}
            width={'60%'}
            borderRadius={Spacing['inline.nano']}
            height={18}
          />
          <Skeleton
            borderRadius={Spacing['inline.nano']}
            height={18}
            marginRight={Spacing['inset.nano']}
          />
        </VStack>
        <VStack width={'30%'}>
          <Skeleton
            marginBottom={Spacing['inset.quarck']}
            width={'80%'}
            borderRadius={Spacing['inline.nano']}
            height={18}
          />
          <Skeleton
            borderRadius={Spacing['inline.nano']}
            height={18}
            marginRight={Spacing['inset.nano']}
          />
        </VStack>
      </HStack>

      <HStack width={'100%'} justifyContent={'space-between'}>
        <HStack>
          <Skeleton size={'5'} marginRight={Spacing['inline.quarck']} borderRadius={'full'} />
          <Skeleton width={20} borderRadius={Spacing['inline.nano']} height={18} />
        </HStack>

        <HStack>
          <Skeleton width={20} borderRadius={Spacing['inline.nano']} height={18} />
          <Skeleton size={'5'} marginLeft={Spacing['inline.quarck']} borderRadius={'full'} />
        </HStack>
      </HStack>
    </VStack>
  );
};
